import React from "react";
import { STHead, STContactUs } from "@/components";
import { getPageContentBySlug } from "@/actions";

export async function getStaticProps() {
  let pageData = null;
  try {
    const res = await getPageContentBySlug("contact-us");
    if (res?.success && res?.data) {
      pageData = res.data;
    }
  } catch (error) {
    console.error("Error fetching contact-us page data:", error);
  }

  return {
    props: {
      pageData,
    },
  };
}

const ContactUs = ({ pageData }) => {
  const pageContent = pageData?.page?.page_content || {};
  const imageUrlBase = pageData?.imageUrl || "https://sustanix.com/";

  const metaTitle = pageContent.meta_title || "Contact Us";
  const metaDescription =
    pageContent.meta_description ||
    "Partnerships is the foundational core for developing advanced biomaterails at Sustanix. We work with the industry, for the industry to transition to a circular economy without any green premium";
  const metaKeywords =
    pageContent.meta_keywords ||
    "Sustanix contact, green chemistry, sustainable additives, support";

  const ogImage = pageContent.og_image
    ? `${imageUrlBase}${pageContent.og_image}`
    : "https://sustanix.com/opengraph-image.webp";

  return (
    <>
      <STHead
        title={metaTitle}
        description={metaDescription}
        keywords={metaKeywords}
        canonicalUrl="https://sustanix.com/contact-us/"
        ogTitle={metaTitle}
        ogDescription={metaDescription}
        ogKeywords={metaKeywords}
        ogUrl="https://sustanix.com/contact-us/"
        ogImage={ogImage}
        ogType="website"
      />
      <STContactUs pageData={pageData} />
    </>
  );
};

export default ContactUs;

